import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "../ui/select";

export const FieldError = ({ msg, testid }) =>
  msg ? <p className="mt-1.5 text-sm text-[#b42318]" role="alert" data-testid={testid}>{msg}</p> : null;

export const Field = ({ label, required, error, children, htmlFor, errorTestid }) => (
  <div>
    <label htmlFor={htmlFor} className="mb-2 block text-sm font-medium text-[#242020]">
      {label} {required && <span className="text-[#650D23]">*</span>}
    </label>
    {children}
    <FieldError msg={error} testid={errorTestid} />
  </div>
);

export const SelectField = ({ id, value, onChange, options, error, testid, placeholder = "Sélectionnez" }) => (
  <Select value={value || undefined} onValueChange={onChange}>
    <SelectTrigger id={id} data-testid={testid} aria-invalid={!!error}
      className={`h-auto rounded-[.7rem] bg-[#FFFDFB] px-4 py-3 text-[.95rem] ${error ? "border-[#b42318]" : "border-[#E3D6C9]"}`}>
      <SelectValue placeholder={placeholder} />
    </SelectTrigger>
    <SelectContent className="bg-[#FFFDFB]">
      {options.map((o) => (
        <SelectItem key={o.value} value={o.value} data-testid={`${testid}-option-${o.value}`}>{o.label}</SelectItem>
      ))}
    </SelectContent>
  </Select>
);
